class Utils { //Classe de utilidades
    constructor(){ //Inicia Singleton (evita múltiplas instâncias)
        if (Utils.instance) {
            return Utils.instance;
        }

        Utils.instance = this;
    }
    
    capitalizeString(str) {
        return str
            .split(' ') // Separa a string em palavras
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitaliza a primeira letra de cada palavra
            .join(' '); // Junta as palavras novamente
    }

    removeAccents(word) {
        return word
            .normalize('NFD') // Normaliza a string para sua forma de decomposição (NFD)
            .replace(/[\u0300-\u036f]/g, ''); // Remove todos os caracteres de acentuação
    }
    
    containsSpecialChars(str) {
        const specialChars = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g;
        return specialChars.test(str);
    }

    containsSpecialCharsEmail(str) {
        const specialChars = /[\{\}\[\]\/?,;:|\)*~`!^\+<>\#$%&\\\=\(\'\"]/g;
        return specialChars.test(str);
    }

    delay(ms) {
        return new Promise((resolve) => setTimeout((resolve), ms));
    }

    handleString(str){
        const strArray = str.toLowerCase().replace(' - ', ' ').split(' '); //transforma a string em vetor com caracteres minúsculos, retirando os hífens que possa ter.
        
        const dashedWords = strArray.map( //Gera novo vetor com hífens ao fim das palavras
            (title,index)=>{
                if(title === '-'){ //Caso ainda tenha algum hífe, retirar.
                    return '';
                }
                
                if (index === strArray.length - 1) { //Não fazer na última palavra
                    return title;
                }
    
                title += '-'; //Adicionar hífen
                return title;
            }
        );

        const dashedTitle = this.removeAccents(dashedWords.join('')); //Juntar vetor de palavras numa única string, sem espaços e acentos. Ex: Título do Produto -> titulo-do-produto
    
        return dashedTitle;
    }
}